import { styled } from '@mui/material';
import { Select } from 'src/components-dummy';

export const SelectWrapperStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  background: theme.palette.custom['gray-70'],
  borderRadius: '4px',
  padding: 0,

  'svg.syte-basic-icon.added-icon': {
    position: 'absolute',
    left: '8px',
    zIndex: 1,
    '& path': {
      stroke: theme.palette.custom['black-10'],
    },
  },
}));

export const SelectStyled = styled(Select)(({ theme }) => ({
  width: '170px',
  height: '26px',
  borderRadius: '4px',
  background: 'transparent',
  '.MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '.MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input': {
    display: 'flex',
    alignItems: 'center',
    height: '26px',
    padding: '5px 30px 5px 34px',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.custom['black-10'],
  },
  'svg.syte-basic-icon.select-caret': {
    right: '8px',
    '& > path': {
      stroke: theme.palette.custom['black-10'],
      strokeWidth: 1.8,
    },
  },
}));
